
$(document).ready(function(){ //タイトル要素をクリックしたら

//  $('.main-product__actions').prepend('<h5 class = "title2">お包について</h3>');

  
});


/*
$(window).on('load', function(){
    if ($('.gpo-app')[0]) {
    $('.gpo-app').css('display','none');

} else {
}});
*/

/*
$(document).on('click','.title2', function() {
  if ($('.gpo-app')[0]) {
    $('.gpo-app').slideToggle();//アコーディオンの上下動作
     if($(this).hasClass('close')){//タイトル要素にクラス名closeがあれば
    $(this).removeClass('close');//クラス名を除去し
  }else{//それ以外は
    $(this).addClass('close');//クラス名closeを付与
  }
} else {
    alert('No exist');
}
});
*/
/*
$(window).on('load', function(){
  const str1 = $("#Option-template--19195778498882__main-0").val();

  if(str1.indexOf("単品")!== -1){
    $('.title2').css('display','none');
     $('.gpo-app').css('display','none');
  }else{
     $('.title2').css('display','');
     $('.gpo-app').css('display','');
  }
});

$(document).on('change','#Option-template--19195778498882__main-0', function() {
  const str1 = $("#Option-template--19195778498882__main-0").val();
    if(str1.indexOf("単品")!== -1){
    $('.title2').css('display','none');
     $('.gpo-app').css('display','none');
    }else{
     $('.title2').css('display','');
     $('.gpo-app').css('display','');
    }
});

*/

$(window).on('load', function(){
  str1 =document.getElementsByClassName(".price__regular");
  //alert(str1);
});



